<template>
  <div v-if="visible" class="modal-overlay mt-lg-5">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{ title }}</h3>
        <button class="close-button" @click="$emit('close')">&times;</button>
      </div>
      <div class="modal-body">
        <div class="">
          <div class="">
            <label>Visited by:</label>
            <p>{{visited}}</p>
          </div>

        </div>
        <div class="">
          <div class="col">
            <label>Dealer Name:</label>
            <p>{{ dealerName }}</p>
          </div>
          <div class="">
            <label>Date and Time:</label>
            <p>{{ dateTimeValue }}</p>
          </div>
          <div class="col">
            <label>Remark:</label>
            <p>{{ remark }}</p>
          </div>
        </div>

        <hr>
        <h4>Checklist</h4>
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>Item Name</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in checklist" :key="item.id">
              <td>{{ item.name }}</td>
              <td>
                <span v-if="item.list_value === '1'" class="correct-mark">&#10003;</span>
                <span v-else class="wrong-mark">&#10007;</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <hr>
        <h4>Items</h4>
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>Item Name</th>
              <th>Sale Qty</th>
              <th>Refill Qty</th>
              <th>Empty Qty</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in tableData" :key="index">
              <td>{{ row.itemName }}</td>
              <td>{{formatQuantity (row.saleQty) }}</td>
              <td>{{formatQuantity (row.refillQty) }}</td>
              <td>{{formatQuantity (row.qty) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    title: String,
    dealerName: String,
    remark: String,
    dateTimeValue: String,
    checklist: Array,
    subCategory: String,
    tableData: Array,
    visited: String,
    newValue: String, // Add newValue prop
  },
  methods :{
    formatQuantity(quantity) {
      return Math.floor(quantity);
    },
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 500px;
  max-width: 80%;
  max-height: 80vh; /* Limit the height to 80% of the viewport height */
  overflow-y: auto; /* Enable vertical scrolling */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

label {
  font-weight: bold;
  margin-right: 10px; /* Add some space between label and value */
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body p {
  display: inline; /* Display p inline to be next to label */
  margin: 0; /* Remove default margin */
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.correct-mark {
  color: green;
  margin-left: 10px;
}

.wrong-mark {
  color: red;
  margin-left: 10px;
}
</style>